<template>
  <div class="flex col-12 full-height">
    <ul class="lg-hide md-hide sm-hide flex justify-center progressbar col-12">
      <li
        v-for="step in steps"
        :key="`${step.name}`"
        class="pointer mx1"
        :class="[
          {
            active: isActive(step),
            stepDisabled: !isActive(step),
            currentStep: currentStep(step)
          },
        ]"
        @click="step.click()"
      >
      </li>
    </ul>
    <ul class="xs-hide flex justify-center progressbar col-12 items-end">
      <li
        v-for="step in steps"
        :key="`${step.name}`"
        class="pointer mx1"
        :class="[
          {
            active: isActive(step),
            stepDisabled: !isActive(step),
            currentStep: currentStep(step)
          },
        ]"
        @click="step.click()"
      >
        <div class="step-label">
          {{ step.label }}
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { changeToPage, injectCurrentParticipant } from '@/utils/logics';
import { getRequiredFields } from '@/utils/utils';
import { computeDataLayerWithoutRoute } from '@/utils/index';

export default {
  computed: {
    user () {
      return this.$store.state.user;
    },
    isSubscriptionTDA () {
      return this.$store.state.subscriptionTDA;
    },
    subscriptionParticipant () {
      return this.cartItem?.participants[0] || {};
    },
    visitedSteps () {
      return this.$store.state.visitedSteps;
    },
    showParticipantStep () {
      return this.$store.state.showParticipantStep;
    },
    showTariffsStep () {
      return this.$store.state.showTariffsStep;
    },
    showSessionsStep () {
      return this.$store.state.showSessionsStep;
    },
    currentParticipant () {
      return this.$store.state.currentParticipant;
    },
    cartItem () {
      const { cartItem } = this.$store.state;
      return cartItem;
    },
    tariffs () {
      return this.cartItem && this.cartItem.tariffs && this.cartItem.tariffs.length ? this.cartItem.tariffs : [];
    },
    canAdvance () {
      switch (this.$route.name) {
        case 'NewTDAParticipants':
          return !!this.currentParticipant;
        case 'NewTDASessions':
          return !!this.cartItem?.session;
        case 'NewTDATariffs':
        case 'NewTDATariffsSubscription':
          return this.tariffs && this.tariffs.length;
        case 'NewTDAParticipantSubscription':
          return this.$store.state.formValid;
        default:
          return true;
      }
    },
    steps () {
      const steps = [];

      if (!this.isSubscriptionTDA) {
        if (this.showParticipantStep) {
          steps.push(
            {
              name: 'NewTDAParticipants',
              label: 'Sélectionnez le participant',
              click: () => {
                if (this.$route.name !== 'NewTDAParticipants') {
                  changeToPage('NewTDAParticipants');
                }
              }
            }
          );
        }

        if (this.showTariffsStep) {
          steps.push(
            {
              name: 'NewTDATariffs',
              label: 'Choisissez vos entrées',
              click: () => {
                if (this.$route.name !== 'NewTDATariffs') {
                  changeToPage('NewTDATariffs');
                }
              }
            }
          );
        }

        if (this.showSessionsStep) {
          steps.push(
            {
              name: 'NewTDASessions',
              label: 'Sélectionnez votre créneau',
              click: () => {
                if (this.$route.name !== 'NewTDASessions') {
                  changeToPage('NewTDASessions');
                }
              }
            }
          );
        }
        const disableRecap = !this.canAdvance || steps.some(step => !this.visitedSteps.includes(step.name));
        steps.push({
          name: 'NewTDACartRecap',
          label: 'Récapitulatif & Paiement',
          click: async () => {
            if (steps.some(step => step.name !== 'NewTDACartRecap' && !this.visitedSteps.includes(step.name))) {
              return;
            }
            if (this.$route.name !== 'NewTDACartRecap') {
              this.$store.commit('setLoading', true);
              this.scrollToTop();
              await injectCurrentParticipant(null, true);
              this.$store.commit('setLoading', false);
            }
          },
          disabled: disableRecap
        });
      } else {
        steps.push(
          {
            name: 'NewTDATariffsSubscription',
            label: 'Abonnement',
            click: () => {
              if (this.$route.name !== 'NewTDATariffsSubscription') {
                this.$store.commit('setShowCustomerForm', false);
                this.$store.commit('setShowEmergencyContactForm', false);
                this.$store.commit('setFormError', null);
                changeToPage('NewTDATariffsSubscription');
              }
            }
          }
        );
        steps.push(
          {
            name: 'NewTDAParticipantSubscription',
            label: 'Informations personnelles',
            click: () => {
              /* Doesn't allow to use stepbar when its the user form edit (auto-redirect from step 1 -> 2) */
              if (!this.getRequiredFields('editCustomer', ['uuid']).every(field => !!this.user[field])) {
                return;
              }
              if (this.$route.name !== 'NewTDAParticipantSubscription') {
                changeToPage('NewTDAParticipantSubscription');
              }
              this.scrollToTop();
              this.$store.commit('setShowCustomerForm', false);
              this.$store.commit('setShowEmergencyContactForm', false);
              this.$store.commit('setFormValid', false);
              this.$store.commit('setFormError', null);
              this.$store.commit('setCartItem', { ...this.cartItem, participants: [] });
              computeDataLayerWithoutRoute('selectParticipant');
            }
          }
        );
        steps.push({
          name: 'NewTDACartRecapRecurring',
          label: 'Récapitulatif d\'achat & Paiement',
          click: async () => {
            if (this.$route.name === 'NewTDACartRecapRecurring') {
              this.scrollToTop();
            }
          },
          disabled: this.$route.name !== 'NewTDACartRecapRecurring'
        });
      }
      this.$store.commit('setSteps', steps);
      return steps;
    }
  },
  methods: {
    getRequiredFields,
    isActive (step) {
      if (this.isSubscriptionTDA) {
        return this.visitedSteps.includes('ResumeOrder') ? !step.disabled : !step.disabled && (this.visitedSteps.includes(step.name));
      }
      return this.visitedSteps.includes('ResumeOrder') ? true : !step.disabled && (this.visitedSteps.includes(step.name));
    },
    scrollToTop () {
      const elem = document.querySelector('#contentDiv');
      if (elem) {
        elem.scrollTo({ top: 0, behavior: 'smooth' });
      }
    },
    currentStep (step) {
      return step.name === this.$route.name;
    }
  }
};
</script>

<style lang="scss" scoped>

.step-label {
  font-size: 0.8rem;
  margin-top: 0.8rem;
  margin-bottom: 0.25rem;
}

.progressbar {
  list-style-type: none;
  margin: 0;
  padding: 0;
  counter-reset: step;
}

.progressbar li {
  width: 30%;
  text-align: center;
  font-size: 24px;
  border-bottom: 2px solid transparent;
}

.progressbar li:before {
  content: counter(step);
  counter-increment: step;
  color: black;
}

.stepDisabled {
  pointer-events: none;
  cursor: none;
  color: #bebebe;
}

.progressbar li.stepDisabled:before {
  color: #bebebe;
}

li.currentStep {
  color: red;
  border-bottom: 2px solid red;
}

.progressbar li.currentStep:before {
  color: red;
}

@media (max-width: 40rem){
  .step-label {
    font-size: 0.6rem;
  }

  .progressbar li {
    width: 20%;
    margin-top: 0.7rem;
  }

  .progressbar li.currentStep:before {
    color: red;
  }
  .currentStep {
    border-bottom: 5px solid red;
  }
}
</style>
